import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getExamDetail } from 'services/store/actions/examAction';
import { Spin, } from 'components/shared/AntComponent';
import { Button } from 'components/shared/FormComponent';

const GenerateQuestion: React.FC = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const { examDetailInfo, loading4 } = useSelector((state: any) => state.exam);

    const getDetail = () => {
        const id = location?.state?.id + "/" + Number(localStorage.getItem('tenantID'));
        dispatch(getExamDetail(id) as any);
    };

    useEffect(() => {
        getDetail();
    }, []);

    return (
        <div className="my-3 children-container">
            <div className="px-0 ">
                <div className="row m-0 page-header">
                    <h5 className="my-auto col text-start ps-2 text-secondary fw-bold">Generate Question Paper</h5>
                    <div className="ms-auto col-md-8 text-end my-auto pe-2">
                        {/* <Button type="primary" className="col-auto ms-2 btn-back" onClick={goToPreviousScreen}>
                            Back
                        </Button> */}
                    </div>
                </div>
            </div>
            <Spin spinning={loading4}>
                <div className="body-content bg-white p-3 mx-0 mt-2 row">
                  <div className='col'>
                    <h6 className='text-dark fw-bold'>Exam Name</h6>
                    <p className='mb-0'>{examDetailInfo?.data?.[0]?.examName||""}</p>
                  </div>
                   <div className='col'>
                    <h6 className='text-dark fw-bold'>Total Marks</h6>
                    <p className='mb-0'>{examDetailInfo?.data?.[0]?.totalMarks||""}</p>
                  </div>
                   <div className='col'>
                    <h6 className='text-dark fw-bold'>Slot</h6>
                    <p className='mb-0'>{examDetailInfo?.data?.[0]?.examName||""}</p>
                  </div>
                </div>
            </Spin>
        </div>
    )
}

export default GenerateQuestion;